module.exports = __webpack_public_path__ + "img/messenger-dark.ac14c467.svg";